import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome';
import BannerLogo from '../../assets/images/Logo.png';

import MobileMenu from './Navigation/MobileMenu.js';
import DesktopMenu from './Navigation/DesktopMenu.js';
import { URL_ROOT } from '../globalConstants.js';

const Header = (props) => {

	const {
		locationId,
		// pages
	} = props;

	const [displayMenu, setDisplayMenu] = useState(false);

	const showMenu = () => {
		setDisplayMenu(true);
	}

	const hideMenu = () => {
		setDisplayMenu(false);
	}

	// const locationPages = pages.filter(x => x.locationId == locationId);

	/*
	const locationPages = [{
	id: 0,
	url: '/About',
	pageDescription: 'Just work',
	name: 'About'
	},{
	id: 1,
	url: '/Home',
	pageDescription: 'Just work',
	name: 'Home'
	},{
	id: 2,
	url: '/2',
	pageDescription: 'Just work',
	name: '2'
	},{
	id: 3,
	url: '/3',
	pageDescription: 'Just work',
	name: '3'
	}];
	*/

	return (
		<header>
			{displayMenu && <MobileMenu locationId={locationId} onClose={() => hideMenu()} />}
			<div className='portalLinkBanner'>
				<a href='https://app.mymusicstaff.com/' target='_blank' rel='noreferrer'>{'Current Client Portal \u{276F}'}</a>
			</div>
			<div className='content'>
				{locationId != null && <button id='showMenuButton' onClick={() => showMenu()}><FontAwesomeIcon icon='bars'></FontAwesomeIcon></button>}
				<div className='heading' onClick={() => window.location = URL_ROOT}>
					<img src={BannerLogo} alt="Banner" title="Banner" />
				</div>
				<a href='https://forms.gle/WotaZvrDCN2eaTRi6' target='_blank' rel='noreferrer' className='absenceFormLink'>Need to miss a lesson?</a>
				<DesktopMenu locationId={locationId} />
			</div>
		</header>
	);
};

const mapStateToProps = state => {
	return {
		pages: state.application.pages
	};
};

export default withRouter(connect(mapStateToProps, null)(Header));
